// ============================================================================
// Web-specific i18n — adapted from lib/i18n.ts.
// Uses navigator.language instead of expo-localization.
// Reuses the same translation tables structure.
// ============================================================================

import { I18n } from "i18n-js";
import en from "./locales/en";
import pt from "./locales/pt";
import es from "./locales/es";
import {
  getDeviceLocale as detectDeviceLocale,
  getInitialLocale,
  setActiveLocale,
  type SupportedLocale,
} from "./locale";

export type { SupportedLocale } from "./locale";

// Translation keys mirror those in lib/i18n.ts
// For brevity, we define the full table inline here.
// In a future refactor, translations could be extracted to a shared package.

type TranslationTable = Record<string, string>;

const translations: Record<SupportedLocale, TranslationTable> = { en, pt, es };

export type TranslationKey = string;

const i18n = new I18n(translations);
i18n.enableFallback = true;

export function getDeviceLocale(): SupportedLocale {
  return detectDeviceLocale();
}

export function setLocale(locale: SupportedLocale) {
  i18n.locale = locale;
  setActiveLocale(locale);
}

export function getLocale(): SupportedLocale {
  const locale = i18n.locale as string;
  if (locale === "pt") return "pt";
  if (locale === "es") return "es";
  return "en";
}

setLocale(getInitialLocale());

export function t(
  key: TranslationKey,
  options?: Record<string, unknown>,
): string {
  return i18n.t(key, options) as string;
}
